module.exports = __webpack_public_path__ + "static/media/SellerboxFuncIconPrize.29f658c1.png";